module.exports = __webpack_public_path__ + "static/img/q6.bd77568.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q6.png
// module id = +FVq
// module chunks = 0